import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const FETCH_SALES_REQUEST = "FETCH_SALES_REQUEST";
export const FETCH_SALES_SUCCESS = "FETCH_SALES_SUCCESS";
export const FETCH_SALES_FAILURE = "FETCH_SALES_FAILURE";

export const fetchSalesOverview = (period = "monthly") => async (dispatch) => {
    dispatch({ type: FETCH_SALES_REQUEST });

    try {
        const response = await axios.get(`${BASE_URL}/v1/api/sales-overview?period=${period}`, {
            headers: {
                authorization: `${localStorage.getItem('token')}`,
            }
        });

        dispatch({
            type: FETCH_SALES_SUCCESS,
            payload: response.data.data
        });
    } catch (error) {
        dispatch({
            type: FETCH_SALES_FAILURE,
            payload: error.message
        });
    }
};
